export default "__VITE_ASSET__84049857__"